import script from "./slideProductTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./slideProductTwo.vue?vue&type=script&setup=true&lang=js"

import "./slideProductTwo.vue?vue&type=style&index=0&id=67f86ca0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67f86ca0"]])

export default __exports__